module.exports = require('react-router-dom');
module.exports.routerRedux = require('react-router-redux');



//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/~/_dva@2.0.4@dva/router.js
// module id = 280
// module chunks = 0 1